var m = require('mithril');
var pointTd = require('../../data/components/pointTd');
var heading = require('../../components/heading');
var edit = require('../../layout/components/edit');
var columnForm = require('../../data/components/columnModal');
var Draggable = require('../../libs/draggable');
var loaders = require('../../layout/components/loaders');
var helpModal = require('../../help/helpModal');
var sortRecovery = require('./sortRecovery');
var unnamedColumnLabel = 'Unnamed column';

function getDatasetRid(element) {
  if (!element || !Array.isArray(element.out_Contains) || !element.out_Contains[0] || !element.out_Contains[0].in) {
    return null;
  }
  return element.out_Contains[0].in['@rid'] || null;
}

function displayColumnName (column) {
  return String((column && column.name) || '').trim();
}

var pointNameTemplate = function (column) {
  var name = displayColumnName(column);
  return name + ' ';
}

function editColumnHandle (column) {
  var name = displayColumnName(column);
  return name || m('i.ion-arrow-move', {'aria-hidden': 'true'});
}

function hasColumnValue(record, key) {
  return Object.prototype.hasOwnProperty.call(record || {}, key) &&
    record[key] !== null &&
    typeof record[key] !== 'undefined' &&
    record[key] !== '';
}

function getColumnBindingIndex(column, fallbackIndex) {
  if (hasColumnValue(column, 'index')) return column.index;
  if (hasColumnValue(column, 'id') && !Number.isNaN(Number(column.id))) return column.id;
  return fallbackIndex;
}

function findColumnPoint(dataset, column, fallbackIndex) {
  var columnEdges = Array.isArray(dataset && dataset.out_Column) ? dataset.out_Column : [];
  var bindingIndex = getColumnBindingIndex(column, fallbackIndex);

  var columnByIndex = columnEdges.find(function (columnEdge) {
    return hasColumnValue(columnEdge, 'index') && String(columnEdge.index) === String(bindingIndex);
  });
  if (columnByIndex) return columnByIndex;

  var columnName = displayColumnName(column);
  return columnEdges.find(function (columnEdge) {
    return displayColumnName(columnEdge) === columnName ||
      displayColumnName(columnEdge && columnEdge.in) === columnName;
  });
}

var oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element || {};
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.sortError = null;
  ctrl.reloadAfterSortError = function () {
    return Promise.resolve()
      .then(function () {
        return typeof ctrl.parentReinitialize === 'function' ? ctrl.parentReinitialize() : null;
      })
      .then(function () {
        ctrl.sortError = null;
        m.redraw();
      })
      .catch(function (error) {
        console.error('Unable to reload list after an order failure:', error);
        return null;
      });
  };
  ctrl.sortChildren = (columns) => {
    var datasetRid = getDatasetRid(ctrl.element);
    if (!datasetRid) {
      return Promise.resolve();
    }
    var rids = (columns || [])
      .map(n => n && n.attributes && n.attributes.rid && n.attributes.rid.value)
      .filter(Boolean);
    return sortRecovery.persistSortOrder({
      context: 'list rows',
      message: 'Unable to reorder list rows. The latest saved order was reloaded.',
      request: function () {
        return loaders.requestWithLoader({
          loader: 'background',
          method: 'PUT',
          url: '/api/v1/dataset/' + datasetRid.slice(1) + '/childorder',
          body: {rids: rids}
        });
      },
      reload: ctrl.parentReinitialize,
      onSuccess: function () {
        ctrl.sortError = null;
      },
      onError: function (message) {
        ctrl.sortError = message;
        m.redraw();
      }
    });
  };
  ctrl.sortOnIndex = (a,b) => {
    return (a.index || 0) - (b.index || 0);
  }

}

var onupdate = function(vnode) {
  this.element = vnode.attrs.element || this.element || {};
  this.parentReinitialize = vnode.attrs.parentReinitialize;
  this.dashboardCallback = vnode.attrs.dashboardCallback;
}

var view = function(vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element || ctrl.element || {};
  var containsEdges = Array.isArray(ctrl.element.out_Contains) ? ctrl.element.out_Contains.filter(edge => edge && edge.in) : [];
  var firstDataset = containsEdges[0] && containsEdges[0].in;
  if (firstDataset && Array.isArray(firstDataset.out_Column)) {
    firstDataset.out_Column.sort(ctrl.sortOnIndex);
  }
  return m('div.f3', [
    ctrl.sortError ? m('div.mt2.mb2.dark-red', [
      m('span', ctrl.sortError + ' '),
      m('button', { type: 'button', onclick: ctrl.reloadAfterSortError }, 'Refresh')
    ]) : null,
    m(heading, {
      label: vnode.attrs.datasetRepresentation && ctrl.element.name == 'Default' ? ctrl.element.parentName : (ctrl.element.name || ''),
      class: 'f1', 
      element: ctrl.element, 
      parentReinitialize: ctrl.parentReinitialize, 
      dashboardCallback: ctrl.dashboardCallback,
      datasetRepresentation: vnode.attrs.datasetRepresentation
    }, [
      ctrl.element.helpText ?
        m('i.ion-ios-information-outline.white.f1.ml2', {
          onclick: () => {
            helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
          }
        })
      :
        ''
    ]),
    containsEdges.map(function (outEdge) {
      var dataset = outEdge.in;
      if (ctrl.element.path) {
        dataset.path = [...ctrl.element.path];
      } else {
        dataset.path = [];
      }
      if (!Array.isArray(dataset.out_Column)) {
        dataset.out_Column = []
      }
      return m('table.w-100', {style: {tableLayout: 'fixed'}}, [
        m(Draggable, {onsort: ctrl.sortChildren, draggable: '.grid-table', handleClass:'.grid-table-drag-handle', htmlElement: 'tbody'},
          vnode.attrs.datasetRepresentation ?
            (dataset.columns || []).sort(ctrl.sortOnIndex).map(function (column, jdx) {
              let columnWithPoint = findColumnPoint(dataset, column, jdx);
              if (columnWithPoint) {
                if (!columnWithPoint.permission) {
                  columnWithPoint.permission = ctrl.element.permission;
                }
                columnWithPoint.path = dataset.path;
                return m('tr.bb', [
                  m('td.f3.man.bb.tl.moon-gray.w-50',  pointNameTemplate(column)),
                  m(pointTd, {
                    columnRecord: columnWithPoint,
                    parentRid: ctrl.element.parentRid || ctrl.element['@rid'],
                    parentReinitialize: ctrl.parentReinitialize
                  }),
                ])
              } else {
                return m('tr.bb', [
                  m('td.f3.man.bb.tl.moon-gray.w-50',  column.name),
                  m('td.f3.man.bb.tl.moon-gray.w-50', '') 
                ])
              }
            })
          :
            dataset.out_Column.map(function (column) {
              column.permission = ctrl.element.permission;
              column.path = dataset.path;
              if (!edit.vm.editing()) {
                return m('tr.bb', [
                  m('td.f3.man.bb.tl.moon-gray.w-50',  pointNameTemplate(column)),
                  m(pointTd, {
                    columnRecord: column,
                    parentRid: ctrl.element.parentRid || ctrl.element['@rid'],
                    parentReinitialize: ctrl.parentReinitialize
                  })
                ])
              } else {
                var label = displayColumnName(column) || unnamedColumnLabel;
                return m('tr.bb.grid-table', {rid: column['@rid']} , [
                  m('td.f3.man.bb.tl.moon-gray.w-50.grid-table-drag-handle',  [
                    m('a.blue', {
                      onclick: columnForm.editDialogue.bind(columnForm, column, { delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize, columnNameRequired: true }),
                      title: label,
                      'aria-label': label
                    }, editColumnHandle(column))
                  ]),
                  m(pointTd, {
                    columnRecord: column,
                    parentRid: ctrl.element.parentRid || ctrl.element['@rid'],
                    parentReinitialize: ctrl.parentReinitialize
                  })
                ])
              }
            })
        ),
        m('div.tc.pv2',  {style: {display: edit.vm.editing() ? '' : 'none'} }, [
          m('i.icon.icon-right.ion-plus.blue', {
            onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], path: dataset.path}, { submitCallback: ctrl.parentReinitialize, columnNameRequired: true })
          })
        ])
      ])
    })
  ])
}

module.exports = {oninit: oninit, onupdate: onupdate, view: view};
